import { lazy } from 'react'

export const AddNewProductModalAsync = lazy(() =>
    import('./AddNewProductModal').then((component) => ({
        default: component.AddNewProductModal,
    }))
)
